import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Switch from '@mui/material/Switch';
import { styled } from "@mui/material/styles";

const Onboardingstep7 = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(true);
  const [formData, setFormData] = useState({
    job_titles: [],
    job_locations: [],
  });
  const [error, setError] = useState({
    job_titles: "",
    job_locations: "",
  }); 
  const [switchState, setSwitchState] = useState({});
  // useEffect(() => {
  //   const storedJobTitles = localStorage.getItem("job_titles");
  //   console.log(storedJobTitles);
  //   const storedJobLocations = localStorage.getItem("job_locations");
  
  //   setFormData({
  //     job_titles: storedJobTitles ? JSON.parse(storedJobTitles) : [],
  //     job_locations: storedJobLocations ? JSON.parse(storedJobLocations) : [],
  //   });
  //   const initialSwitchState = {};
  //   formData.job_titles.forEach((title) => {
  //     formData.job_locations.forEach((location) => {
  //       initialSwitchState[`${title}-${location}`] = false; 
  //     });
  //   });
  //   setSwitchState(initialSwitchState);
  // }, []);
  useEffect(() => {
    const storedJobTitles = localStorage.getItem("job_titles");
    const storedJobLocations = localStorage.getItem("job_locations");
  
    setFormData({
      job_titles: storedJobTitles ? JSON.parse(storedJobTitles) : {},
      job_locations: storedJobLocations ? JSON.parse(storedJobLocations) : [],
    });
  
    // Initialize switch states
    const initialSwitchState = {};
    Object.keys(formData.job_titles).forEach((id) => {
      formData.job_locations.forEach((location) => {
        initialSwitchState[`${id}-${location}`] = false;
      });
    });
    setSwitchState(initialSwitchState);
  }, []);
  const titlecount= formData.job_titles.length;
  const locationcount= formData.job_locations.length;
  const total = titlecount * locationcount; 

  const handleChange = (title, location) => (event) => {
    setSwitchState((prev) => ({
      ...prev,
      [`${title}-${location}`]: event.target.checked,
    }));
  };
  const validateForm = () => {
    let isValid = true;
    let errors = {};

    if (formData.job_titles.length === 0) {
      errors.job_titles = "At least one job title is required";
      isValid = false;
    }

    if (formData.job_locations.length === 0) {
      errors.job_locations = "At least one job location is required";
      isValid = false;
    }

    setError(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
    //   try {
    //     const response = await axios.post("YOUR_API_URL/onboarding/step5", formData);
    //     if (response.status === 200) {
    //       navigate("/user/onboarding/step6");
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    navigate("/user/onboarding/step8");
    }
  };
  const CustomSwitch = styled(Switch)(({ theme }) => ({
    transform: "scale(1.5)", // Increases switch size
    "& .MuiSwitch-thumb": {
      width: 24,
      height: 24,
    },
    "& .MuiSwitch-switchBase": {
      padding: 12,
    },
  }));
  return (
    <div className="flex flex-col items-center justify-start mt-16 min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md text-center mb-4">
        <p className="text-2xl mb-2">Get Notified when new jobs are posted</p>
        <p className="text-[14px] text-gray-500">
          {total} job alerts that best match what yoy are looking for. You can
          create more later.
        </p>
      </div>
      <div className="w-full max-w-md">
        <div className="w-full max-w-md flex flex-col justify-between items-center space-y-2 px-12 py-4">
        {Object.entries(formData.job_titles).map(([id, title]) =>
            formData.job_locations.map((location) => (
              <div key={`${title}-${location}`} className="flex items-center justify-between w-full">
                <div className="flex flex-col items-start">
                  <p className="text-[14px] text-gray-900 font-semibold">
                    {title}
                  </p>
                  <p className="text-[14px] text-gray-600">{location}</p>
                </div>
                <div>
                <   Switch
                    checked={switchState[`${title}-${location}`] || false}
                    onChange={handleChange(title, location)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div>
            ))
          )}
        </div>
        <div className="mt-4 flex flex-col items-center px-12">
          <button
            className="bg-[#0A66C2] hover:bg-blue-700 text-white text-lg font-bold py-2 px-4 h-12 rounded-full w-full"
            type="button"
            onClick={handleSubmit}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Onboardingstep7;
